import { AVATAR_IDS, type AvatarId } from '@guess/protocol';

/**
 * Les huit avatars.
 *
 * De VRAIES icones vectorielles — des formes geometriques nettes, pas des
 * emoji. Chacune est un unique `<path>` ou groupe de formes simples, dessinee
 * dans une boite 24x24 pour que toutes s'alignent, quelle que soit leur
 * forme reelle. Le trait est `currentColor` : c'est le fond du jeton qui
 * porte la couleur choisie, pas l'icone elle-meme.
 *
 * La LISTE des identifiants vient du protocole (`AVATAR_IDS`), pas d'ici :
 * c'est le serveur qui valide un choix, le client ne fait que dessiner.
 */
export { AVATAR_IDS };

function Bolt() {
  return <path d="M13 2 4 14h6l-1 8 9-12h-6l1-8Z" />;
}

function Ghost() {
  return (
    <path d="M12 2a8 8 0 0 0-8 8v11l2.5-2 2.5 2 3-2.4 3 2.4 2.5-2 2.5 2V10a8 8 0 0 0-8-8Zm-3 8.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm6 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z" />
  );
}

function Diamond() {
  return <rect x="4.5" y="4.5" width="15" height="15" transform="rotate(45 12 12)" />;
}

function Star() {
  return (
    <path d="M12 2.5 15 9.5 22 10.3 16.8 15 18.3 21.9 12 18.3 5.7 21.9 7.2 15 2 10.3 9 9.5Z" />
  );
}

function Hex() {
  return <path d="M8 3h8l5 9-5 9H8l-5-9Z" />;
}

function Ring() {
  return (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm0 5a5 5 0 1 0 0 10 5 5 0 0 0 0-10Z"
    />
  );
}

function Triangle() {
  return <path d="M12 2 22 21H2Z" />;
}

function Cross() {
  return <path d="M9.5 2h5v7.5H22v5h-7.5V22h-5v-7.5H2v-5h7.5Z" />;
}

const GLYPHS: Record<AvatarId, () => JSX.Element> = {
  bolt: Bolt,
  ghost: Ghost,
  diamond: Diamond,
  star: Star,
  hex: Hex,
  ring: Ring,
  triangle: Triangle,
  cross: Cross,
};

export interface AvatarGlyphProps {
  avatarId: AvatarId;
  className?: string | undefined;
}

/** Le seul point d'entree : le reste du client ne connait pas les paths. */
export function AvatarGlyph({ avatarId, className }: AvatarGlyphProps) {
  const Glyph = GLYPHS[avatarId];
  return (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <Glyph />
    </svg>
  );
}
